import { createContext, useCallback, useContext, useEffect, useRef } from 'react';
import type { FormInstance } from 'antd';

type FormsRegistryRef = React.RefObject<Map<string, FormInstance>>;

export const FormsRegistryContext = createContext<FormsRegistryRef | undefined>(undefined);

export const FormsRegistryProvider = ({ children }: { children: React.ReactNode }) => {
  const registryRef = useRef<Map<string, FormInstance>>(new Map());
  return <FormsRegistryContext.Provider value={registryRef}>{children}</FormsRegistryContext.Provider>;
};

export const useRegisterForm = (form: FormInstance, name: string) => {
  const registryRef = useContext(FormsRegistryContext);
  useEffect(() => {
    if (!registryRef) {
      return;
    }
    registryRef.current.set(name, form);
    return () => {
      registryRef.current.delete(name);
    };
  }, [registryRef, form, name]);
};

export const useGetForm = (name: string) => {
  const registryRef = useContext(FormsRegistryContext);
  return useCallback(() => registryRef?.current.get(name), [registryRef, name]);
};
